export class Agreements {
  public static mg = "https://prestemos-assets.s3.us-east-1.amazonaws.com/png/mg.png";
  public static jac = "https://prestemos-assets.s3.us-east-1.amazonaws.com/png/jac.png";
  public static kia = "https://prestemos-assets.s3.us-east-1.amazonaws.com/png/kia.png";
  public static chirey = "https://prestemos-assets.s3.us-east-1.amazonaws.com/png/chirey.png";
}
